module.exports = __webpack_public_path__ + "static/media/ar21_gjohnson.e2d1414c.jpeg";